import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { loadPersonalStrategies } from '../../actions/data';
import { getStrategies, getStrategy, getOptimizedStrategy } from '../../reducers/data';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faTrashAlt,
  faEdit,
  faMinusCircle,
  faQuestionCircle,
  faBars,
  faChevronUp,
  faChevronCircleUp
} from '@fortawesome/free-solid-svg-icons';
import Strategy from './Strategy/Strategy';
import Model from './Model/Model';
import Info from './Info/Info';
// import { test } from 'wwt-react/dist/util/functions';
import './App.css';

// Initialize the Font Awesome library
library.add(faTrashAlt, faEdit, faMinusCircle, faQuestionCircle, faBars, faChevronUp, faChevronCircleUp);

class App extends PureComponent {

  componentDidMount() {
    this.props.loadPersonalStrategies();
  }

  render() {
    const {
      strategy,
      optimized,
    } = this.props;

    let hasModel = false;
    if(optimized && optimized.length > 1) {
      const model = optimized[1];
      if(model.modelProposalTicker !== null) {
        hasModel = true;
      }
    }

    if (strategy) {
      return (
        <div id="most-recent-portfolio" className="asd">
          {strategy &&
            <React.Fragment>
              <div style={{fontSize:'28px',lineHeight:'36px',marginTop:'60px',marginBottom:'30px'}}>Your Most Recent Portfolio</div>
              <Strategy strategy={strategy} />
              <div style={{marginTop:'30px',marginBottom:'35px'}}>
                <a href={'#myportfolios&myportfolioid=' + strategy.id} style={{textDecoration:'none',fontSize:'18px',color:'#05A9B1',fontWeight:'900'}}>Open in My Portfolio Hub</a>
              </div>
            </React.Fragment>
          }
        
          {hasModel &&
            <React.Fragment>
              <div style={{width:'100%',borderTop:'2px dotted #CBCBCB',height:'1px'}}></div>
              <div style={{fontSize:'28px',lineHeight:'36px',marginTop:'60px',marginBottom:'30px'}}>Proposed Model*</div>
              <Model name={strategy.name} strategy={optimized[0]} model={optimized[1]} />
            </React.Fragment>
          }

          {strategy &&
            <React.Fragment>
              <Info />
              <div style={{marginTop:'30px',marginBottom:'35px'}}>
                <a href={'#toolscenter'} style={{textDecoration:'none',fontSize:'18px',color:'#05A9B1',fontWeight:'900'}}>View Digital Portfolio Developer (DPD)</a>
              </div>
            </React.Fragment>
          }

          {strategy && !hasModel &&
            <div className="asd">
              <div className='banner'>
                <div className='banner-title'>MODERN ALPHA ETF MODEL PORTFOLIOS</div>
                <div className='banner-text'>
                Leverage wide range of model portfolios we built for you or build your own using our asset<br />
                allocation building blocks to bring Modern Alpha into your existing portfolios.
                </div>
                <button onClick={() => window.location.href='/advisor-solutions/about-etf-model-portfolios'} className='banner-button'>ACCESS MODEL PORTFOLIOS</button>
              </div>
              <div style={{marginBottom:'35px'}}>&nbsp;</div>
            </div>
          }
        </div>
      );
    } else {
      return (
        <div className="asd">
          <div className='banner'>
            <div className='banner-title'>DIGITAL PORTFOLIO DEVELOPER</div>
            <div className='banner-text'>
              Improve your existing portfolios - or build custom ones from scratch<br />
              with our groundbreaking portfolio construction tool.
            </div>
            <button onClick={() => window.location.href='#myportfolios&newstrategy'} className='banner-button'>UPLOAD YOUR PORTFOLIO</button>
          </div>
          <div id='dpd-banner' style={{marginTop:'60px',marginBottom:'35px'}}>
            <a href={'#toolscenter'} style={{textDecoration:'none',fontSize:'18px',color:'#05A9B1',fontWeight:'900'}}>View Digital Portfolio Developer (DPD)</a>
          </div>
        </div>
      );
    }
  }
}

function mapStateToProps(state) {
  return {
    strategies: getStrategies(state),
    strategy: getStrategy(state),
    optimized: getOptimizedStrategy(state),
  };
}

export default connect(
  mapStateToProps,
  {
    loadPersonalStrategies,
  },
)(App);
